import { app, Component, ojs } from "modular-openscriptjs";
import CapaForm from "./CapaForm";
import MpesaForm from "./MpesaForm";
import OfflineMpesaForm from "./OfflineMpesaForm";

const h = app("h");

ojs(CapaForm);
ojs(MpesaForm);
ojs(OfflineMpesaForm);

export default class PaymentForm extends Component {
	render(method, ...args) {
		let m = method.value;

		switch (m) {
			case "mpesa":
				return this.mpesa(...args);
			case "capa":
				return this.capa(...args);
			case "offlineMpesa":
				return this.offlineMpesa(...args);
			default:
				return this.mpesa(...args);
		}
	}

	mpesa(...args) {
		return h.MpesaForm(...args);
	}

	capa(...args) {
		return h.CapaForm(...args);
	}

	offlineMpesa(...args) {
		return h.OfflineMpesaForm(...args);
	}
}

ojs(PaymentForm);
